import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import ClientSessionHistoryView from '../../components/ClientSessionHistoryView';

const SessionsSection = () => (
  <Card>
    <CardContent>
      <Typography variant="h6" gutterBottom>
        My Session History
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Recent simulation sessions you have run. Select a session to continue where you left off.
      </Typography>
      <ClientSessionHistoryView />
    </CardContent>
  </Card>
);

export default SessionsSection;
